import React, { Component } from "react";
import { connect } from "react-redux";
import { createHashHistory } from "history";
import PropTypes from "prop-types";
import {
  FormGroup,
  InputGroup,
  FormControl,
  Button,
  Alert
} from "react-bootstrap";
import Pagination from "react-js-pagination";
import { NewBreadcrumb as BreadcrumbComponent } from "../../components";

import {
  get_all_city,
  delete_city
} from "../../redux/actions/countryCityActions";
import isEmpty from "lodash.isempty";
import "../../style/react-paginating.css";
import "../../style/cityAndCountry/cityStateCountryList.scss";
import Dialog from "react-bootstrap-dialog";

const history = createHashHistory();
class CityStateCountryList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cities: [],
      totalRecords: 0,
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "",
      path: ["Home", "Cities"],
      links: ["home","cityAndCountry"],
      search: "",
      limit: 25,
      show: false,
      isLoading: false,
      titleIcon: "fa fa-sort-down",
      stateIcon: "fa fa-sort-down",
      direction: "",
      orderBy: ""
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleSearch(e) {
    this.setState({ [e.target.name]: e.target.value });
    let searchstring = e.target.value.length > 0 ? e.target.value : "";
    const postData = {
      page: 1,
      limit: 25,
      search: searchstring
    };
    if (searchstring.length > 0) {
      this.props.get_all_city(postData);
    }else{
      this.props.get_all_city({ page: this.state.page, limit: this.state.limit });
    }
  }

  handleSort = orderBy => e => {
    e.preventDefault();
    let direction;
    const sortIcon = `${orderBy}Icon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "fa fa-sort-up",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "fa fa-sort-down",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "fa fa-sort-up",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.get_all_city({
      orderBy: orderBy,
      direction: direction,
      limit: this.state.limit
    });
  };

  componentWillMount() {
    if (this.props.cityResponse && this.props.cityResponse.message) {
      this.setState({
        alertMessage: this.props.cityResponse.message,
        msgType: "success",
        show: true
      });
    }
    if (this.props.cityUpdate && this.props.cityUpdate.message) {
      this.setState({
        alertMessage: this.props.cityUpdate.message,
        msgType: "success",
        show: true
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.fetchingCities !== nextProps.fetchingCities) {
      this.setState({ isLoading: nextProps.fetchingCities });
    }
    if (
      this.props.citiesList !== nextProps.citiesList &&
      !isEmpty(nextProps.citiesList)
    ) {
      const setPageCount =
        nextProps.citiesList.total / nextProps.citiesList.per_page;
      this.setState({ cities: nextProps.citiesData });
      this.setState({ totalRecords: nextProps.citiesList.total });
      this.setState({ perPage: nextProps.citiesList.per_page });
      this.setState({ pageCount: setPageCount });
    }
    if (
      this.props.deletedCity !== nextProps.deletedCity &&
      !isEmpty(nextProps.deletedCity)
    ) {
      if (nextProps.deletedCity.message) {
        this.setState({
          alertMessage: nextProps.deletedCity.message,
          msgType: "success",
          show: true
        });
        this.props.get_all_city({
          page: this.state.currentPage,
          limit: this.state.limit
        });
      }
    }
    if (this.props.error !== nextProps.error) {
      this.setState({
        alertMessage: nextProps.error,
        msgType: "warning",
        show: true
      });
    }
  }

  componentDidMount() {
    this.handlePageChange(1);
  }
  componentWillUnmount() {
    this.setState({ alertMessage: "", msgType: "", show: false });
  }

  handlePageChange = page => {
    this.setState({
      currentPage: page
    });

    if (this.state.direction !== "" && this.state.orderBy !== "") {
      this.props.get_all_city({
        page: page,
        orderBy: this.state.orderBy,
        direction: this.state.direction,
        limit: this.state.limit
      });
    } else if (this.state.searchString !== "") {
      this.props.get_all_city({
        page: page,
        search: this.state.search,
        limit: this.state.limit
      });
    } else {
      this.props.get_all_city({ page: page, limit: this.state.limit });
    }
  };

  confirmDelete = cityID => {
    this.props.delete_city(cityID);
  };

  handleDelete(cityID) {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(cityID);
          this.handleShow();
        })
      ]
    });
  }

  render() {
    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    const Header = [
      "City Id",
      "Title",
      "State",
      "Country Name",
      "Status",
      "View",
      "Edit",
      "Delete"
    ];
    let cityRow;
    let citiesdata = this.state.cities ? this.state.cities : [];
    if (citiesdata) {
      cityRow = citiesdata.map((city, index) => (
        <tr key={city.cityID}>
          <td>{city.title}</td>
          <td>{city.state}</td>
          <td>{city.country}</td>
          {/*<td>{city.status}</td>*/}
          <td>
            <Button
              bsStyle="success"
              onClick={() =>
                history.push(`/CityStateCountryDetails/${city.cityID}`)
              }
            >
              {" "}
              View{" "}
            </Button>
            &nbsp;
            <Button
              bsStyle="info"
              onClick={() => history.push(`/AddCity/${city.cityID}`)}
            >
              {" "}
              Edit{" "}
            </Button>
            &nbsp;
            <Button
              bsStyle="danger"
              onClick={this.handleDelete.bind(this, city.cityID)}
            >
              {" "}
              Delete{" "}
            </Button>
          </td>
        </tr>
      ));
    }

    return (
      <div className="col-lg-12 city-state-country-list">
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
          </div>
        </div>
        <div className="panel">
          <header className="panel-heading">Manage Cities</header>
          <div className="panel-body">
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
            {this.state.isLoading ? (
              <div className="loader">
                <p className="loading-message">
                  <i>Loading...</i>
                </p>
                <div className="spinner">
                  <div className="dot1" />
                  <div className="dot2" />
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="col-lg-12 text-right">
              <Button
                bsStyle="success"
                onClick={() => history.push("/AddCity")}
              >
                + Add New City
              </Button>
            </div>
            <div className="clearfix" />
            <div className="row m-t-15">
              <div className="col-lg-4 pull-right">
                <FormGroup>
                  <InputGroup>
                    <FormControl
                      type="text"
                      name="search"
                      onChange={this.handleSearch}
                    />
                    <InputGroup.Addon>
                      <i className="fa fa-search" />
                    </InputGroup.Addon>
                  </InputGroup>
                </FormGroup>
              </div>
            </div>
            <div className="col-lg-12">
              <table className="table table-hover" responsive="true">
                <thead>
                  <tr>
                    <th onClick={this.handleSort("title")}>
                      City{" "}
                      <span
                        className={this.state.titleIcon}
                        aria-hidden="true"
                      />
                    </th>
                    <th onClick={this.handleSort("state")}>
                      State{" "}
                      <span
                        className={this.state.stateIcon}
                        aria-hidden="true"
                      />
                    </th>
                    <th> Country </th>
                    {/*<th> Status </th>*/}
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>{cityRow}</tbody>
              </table>

              <div className="text-center">
             

<Pagination
                  activePage={currentPage}
                  itemsCountPerPage={perPage}
                  totalItemsCount={totalRecords}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              </div>
            </div>
            <div className="clearfix" />
          </div>
        </div>
      </div>
    );
  }
}

CityStateCountryList.propTypes = {
  get_all_city: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  citiesList: state.countryCityReducers.citiesList,
  citiesData: state.countryCityReducers.citiesData,
  deletedCity: state.countryCityReducers.deletedCity,
  error: state.countryCityReducers.error,
  cityResponse: state.countryCityReducers.cityResponse,
  cityUpdate: state.countryCityReducers.cityUpdate,
  fetchingCities: state.countryCityReducers.fetchingCities
});

export default connect(mapStateToProps, { get_all_city, delete_city })(
  CityStateCountryList
);



// WEBPACK FOOTER //
// ./src/app/views/cityAndCountry/CityStateCountryList.js